// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Footer.css')));

var component = ReasonReact.statelessComponent("Notice");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "footer"
                }, React.createElement("p", undefined, "Touch (mobile) / Arrow Keys (Desktop)"), React.createElement("p", undefined, "Made with Reason by ", React.createElement("a", {
                          className: "github_link",
                          href: "https://github.com/sevenseat"
                        }, "John Schweikert")), React.createElement("p", undefined, "Forked From ", React.createElement("a", {
                          className: "github_link",
                          href: "https://github.com/LIU9293"
                        }, "liu kai")));
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.re
// module id = 33
// module chunks = 0